module.exports = __webpack_public_path__ + "img/donut_half.491fd313.svg";